module.exports = __webpack_public_path__ + "img/9-aos-guide.e887015f.webp";